<template>
  <div>
    <!--General Top Bar -->
    <general-top-bar :title="$t('reports.productSaleTrendsReport')"></general-top-bar>
    <!--End General Top Bar -->
    <div class="sales-report">
      <div class="row mar-bt-15">
        <!-- Left Column -->
        <div class="col-md-6" v-if="showLocations">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <template v-for="loc in locations">
                <option :label="loc.name" :value="loc.id">{{loc.name}}</option>
              </template>
            </select>
          </div>
        </div>
        
        <!-- Right Column -->
        <div class="col-md-6">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('reports.products')}}</label>
            <el-select
              v-model="selectedProducts"
              ref="productSelect"
              value-key="id"
              multiple
              filterable
              remote
              collapse-tags
              reserve-keyword
              label="label"
              style="width: 100%"
              :placeholder="$t('reports.searchProducts')"
              :remote-method="searchProducts"
              :loading="loadingProducts"
              @change="clearSearch">
              <el-option
                v-for="item in mergedProducts"
                :key="item.id"
                :label="item.label"
                :value="item">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <div class="pull-left" 
            style="display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;"
          >
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_from"
              v-model="valid_from"
              style="margin-left: 10px;"
              :change="changeValidFrom()"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_to"
              v-model="valid_to"
              :change="changeValidFrom()"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </div>
        </p>
        <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
        </div>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">{{ $t('reports.filteredData') }} <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:59</b></p>
      </div>

      <div class="col-md-12">
        <!-- <div class="card"> -->
          <div class="card-content total-pagination reports-center-columns">
            <line-chart :chartData="chartData" :options="chartOptions" />
          </div>
        <!-- </div> -->
      </div>
      <div class="col-md-12" style="margin-top: 15px;">
        <data-tables-server
          v-loading="loading"
          :data="ordersTableData.data"
          :search-def="{show: false}"
          @query-change="paginationChanged"
          :total="ordersTableData.total"
          :pagination-props="paginationProps"
          class="report-sales"
          key="sales-table"
          style="width: 100%"
          ref="reportsTable">
          <el-table-column class-name="centered-cell" :min-width="80" prop="product_name" :label="$t('reports.productName')" />
          <el-table-column class-name="centered-cell" :min-width="80" prop="quantity_sold" :label="$t('reports.quantity')" />
          <el-table-column class-name="centered-cell" :min-width="80" prop="total_sold" :label="$t('reports.revenue')">
            <template slot-scope="props">
              {{ formatMoneyAmount(Number(props.row.total_sold)) }}
            </template>
          </el-table-column>
          <el-table-column class-name="centered-cell" :min-width="80" prop="sale_date" :label="$t('reports.date')" />
        </data-tables-server>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import JsonExcel from 'vue-json-excel'
import LineChart from 'src/components/UIComponents/Cards/LineChart.vue'
Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    GeneralTopBar,
    [DatePicker.name]: DatePicker,
    LineChart
  },
  props: {
    isSalesProductsTrend: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isSalesProductsTrend () {
      if (this.isSalesProductsTrend) {
        this.getOrders()
        this.verifyUserLocations()
        this.verifyUserMethods()
      }
    }
  },
  // created () {
  //   this.getOrders()
  //   this.verifyUserLocations()
  //   this.verifyUserMethods()
  // },
  computed: {
    mergedProducts () {
      const map = new Map(this.availableProducts.map(t => [t.id, t]))
      this.selectedProducts.forEach(t => {
        if (!map.has(t.id)) {
          map.set(t.id, t)
        }
      })
      return Array.from(map.values())
    }
  },
  data () {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      productsTableData: [],
      productsTableDataTotals: {},
      paymentMethods: [],
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_method: '',
      loading: true,
      loadingProducts: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      ordersTableData: {},
      totals: {
        total: 0,
        totalCash: 0,
        totalVirament: 0,
        totalOnline: 0,
        totalProtocol: 0,
        totalCard: 0,
        totalPOS: 0,
        totalCARDPOS: 0,
        totalTips: 0,
        totalDiscount: 0,
        totalTax: 0,
        totalShipping: 0,
        avarageOrderValue: 0
      },
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '550px',
          width: '550px'
        }
      },
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Vânzari',
              fontColor: 'red',
              fontSize: 22
            },
            ticks: { beginAtZero: true }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Data',
              fontColor: 'red',
              fontSize: 22
            }
          }]
        }
      },
      // use_tips: this.$session.get('tips_use')
      use_tips: true,
      noData: false,
      selectedProducts: [],
      availableProducts: [],
      allProductsMap: new Map()
    }
  },
  methods: {
    searchProducts (query) {
      if (!query) {
        return
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loadingProducts = true

      this.apiRequest('/search-order-products', 'GET', data, response => {
        if (response.status) {
          response.data.forEach(item => {
            this.allProductsMap.set(item.id, item)
          })

          this.availableProducts = response.data
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loadingProducts = false
        })
      })
    },
    clearSearch () {
      this.$refs.productSelect.focus()
      const select = this.$refs.productSelect

      if (select) {
        select.query = ''
        select.handleQueryChange('')
      }
    },
    getPaymentMethods () {
      let sessionData = this.$session.get('selectedCompanyData')

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/orders/get-payment-methods', 'GET', data, (response) => {
          if (response.status && response.data.length) {
            let result = response.data.map(item => {
              return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
            })
            sessionData['payment_methods'] = response.data
            this.$session.set('selectedCompanyData', sessionData)

            Vue.set(this, 'paymentMethods', result)
          }
        })
      } else {
        let result = sessionData['payment_methods'].map(item => {
          return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
        })
        Vue.set(this, 'paymentMethods', result)
      }
    },
    summaryTotal () {
      const result = {
        revenue: 0,
        quantity: 0,
        discount: 0,
        vat: 0
      }

      this.productsTableData.forEach(item => {
        result.revenue += Number(item.total_revenue || 0)
        result.quantity += Number(item.quantity_sold || 0)
        result.discount += Number(item.discount || 0)
        result.vat += Number(item.vat || 0)
      })

      return result
    },
    startDownload () {
      this.loading = true
    },
    finishDownload () {
      this.loading = false
    },
    changeValidFrom () {
      // if (this.valid_to <= this.valid_from) {
      //   this.valid_to = '23:59'
      // }
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    paginationChanged (query) {
      if (query.type === 'page') this.getOrders(query)
      if (query.type === 'size') this.getOrders(query)
      if (query.type === 'sort') this.getOrders(query)
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    getOrders (query) {
      if (!this.isSalesProductsTrend) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }
      if (this.selectedProducts && this.selectedProducts.length) {
        data.product_ids = this.selectedProducts.map(table => table.id)
      }
      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }
      this.loading = true
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1

      this.apiRequest('/reports/v2/product-trends' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, response => {
        if (response.status) {
          if (response.data.table_data.length) {
            this.ordersTableData.data = response.data.table_data
            this.ordersTableData.total = response.pagination.total
            this.paginationProps.currentPage = response.pagination.page
            this.paginationProps.pageSize = response.pagination.perPage
          } else {
            this.ordersTableData.data = []
            this.ordersTableData.total = 0
          }

          this.$nextTick(() => {
            this.chartData = {
              labels: response.data.labels,
              datasets: response.data.datasets
            }
          })
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    exportData () {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      this.apiRequest('/reports/v2/product-trends-download', 'GET', data, response => {
        if (response.status === true) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name)
          document.body.appendChild(link)
          link.click()
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.loading = false
      })
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  /* .ct-label.ct-horizontal {
    white-space: pre-line;
    text-anchor: middle;
    font-size: 12px;
  } */
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  /* .ct-chart {
    overflow: visible !important;
  } */

  .ct-chart {
    padding-top: 20px; /* or more */
    overflow: visible !important;
  }

  .centered-cell .cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>

<style scopped>
  .el-select .el-tag {
    background-color: #674BD2 !important;
    color: white;
    /* font-size: 16px; */
    padding: 2px 12px;
  }

  span .el-tag {
    padding-top: 7px !important;
    height: 36px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/SalesProductsTrend.vue